import Axios from 'axios';
import ApiError from './ApiError';
import ERRORS from './errorConstants';
import { APP_DOMAIN, TOKEN_URL } from '../constants/app-constants';
import Actions from '../pages/userComponents/menus/salesforce-landing/action';

const setupInterceptors = (store) => {
	// Default settings for Axios request
	Axios.defaults.headers.post['Content-Type'] = 'application/json';
	Axios.defaults.validateStatus = () => true;
	Axios.interceptors.request.use(
		(config) => {
			let token = localStorage.getItem('token');
			console.log(config);
			config.headers.Authorization = token ? `Bearer ${token}` : null;
			return config;
		},
		(error) => Promise.reject(error)
	);
	Axios.interceptors.response.use(
		(response) => {
			// Process response body
			const originalRequest = response.config;
			if (response.status && parseInt(response.status, 0) > 205) {
				switch (response.status) {
					case 500:
						throw new ApiError(ERRORS.SERVER_ERROR);
					case 401:
						console.log('UNAUTHORISED_ERROR');
						if (!originalRequest._retry) {
							originalRequest._retry = true;

							const params = new URLSearchParams();
							// TODO : Need to update configuration in pipeline library
							params.append('client_id', '549af87db51544d99d7d68aacdc2bec8');
							params.append('client_secret', 'LYi16CbzGfS6wRDHgfYrVoLrudK1WvRQd1TY6A5s');
							params.append('grant_type', 'client_credentials');
							params.append('scope', 'erae-onboarding-api');
							params.append('acr_values', 'tenant:ae');

							return Axios.post(TOKEN_URL, params).then((res) => {
								if (res.status === 200) {
									// 1) put token to LocalStorage
									localStorage.setItem('token', res.data.access_token);

									store.dispatch(Actions.creators.getTokenActionSuccess(res.data));
									// 2) Change Authorization header
									Axios.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('token');

									// 3) return originalRequest object with Axios.
									return Axios(originalRequest);
								}
							});
						}

					case 403:
						throw new ApiError(ERRORS.FORBIDDEN_ERROR, response.data.error.message);
					case 406:
						throw new ApiError(ERRORS.UNAUTHORISED_ERROR, response.data.error.message);
					case 400:
						let message = 'Something went wrong';
						message = response && response.data ? response.data : message;
						throw new ApiError({
							name: '',
							message: message,
						});
					case 404:
						// throw response.data.;
						throw new ApiError(ERRORS.CLIENT_ERROR);
					default:
						throw new ApiError(ERRORS.CLIENT_ERROR);
				}
			} else {
				return response;
			}
		},
		(error) => Promise.reject(error)
	);
};

export default setupInterceptors;
